import { useTranslation } from 'react-i18next'
import c from './assets/sass/info.module.scss'

export const Info = () => {
    const { t } = useTranslation()
    return (
        <div className={c.component}>
            <h3 className={c.logo}>{t('splash.title')}</h3>
            <span className={c.description}>{t('splash.description')}</span>
        </div>
    )
}
